
const state = {
    start_date: localStorage.getItem('start_date') || '',
    end_date: localStorage.getItem('end_date') || '',
};

const mutations = {
    SET_START_DATE(state, startDate) {
        state.start_date = startDate;
        localStorage.setItem('start_date', startDate);  // Save to localStorage
    },
    SET_END_DATE(state, endDate) {
        state.end_date = endDate;
        localStorage.setItem('end_date', endDate);  // Save to localStorage
    },
    DELETE_DATA(state) {
        state.start_date = null;
        state.end_date = null;
        localStorage.removeItem('start_date');
        localStorage.removeItem('end_date');
    }
};

const actions = {
    setStartDate({ commit }, startDate) {
        commit('SET_START_DATE', startDate);  // Commit the mutation
    },
    setEndDate({ commit }, endDate) {
        commit('SET_END_DATE', endDate);  // Commit the mutation
    },
    deleteData({ commit }) {
        commit('DELETE_DATA', state);
    }
};

const getters = {
    start_date: (state) => state.start_date,
    end_date: (state) => state.end_date,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
